const SwitchV2 = ({
  label,
  onChange,
  value,
}: {
  label: string;
  value: boolean;
  onChange: (val: any) => void;
}) => {
  return (
    <label className="inline-flex items-center cursor-pointer">
      <input
        type="checkbox"
        className="sr-only peer"
        checked={value}
        onChange={(event) => onChange(event.target.checked)}
      />
      <div className="relative w-11 h-6 bg-white border-[1px] border-[#8138df66] peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white peer-checked:after:bg-white after:content-[''] after:absolute after:top-[1px] after:start-[2px] after:border-gray-300 after:border after:bg-[#8138df66] after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-[#1c1c2c]"></div>
      <span className="ms-3 text-sm font-medium text-gray-900 select-none">
        {label}
      </span>
    </label>
  );
};

export default SwitchV2;
